// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__YJLJo","tooltip_text":"styles_tooltip_text__84Sap"};